<template>
  <!--用户信息-->
  <div class="user-info">
    <div class="exit"
         @click="exit">退出</div>
    <div class="main">
      <img :src="userInfo.avatar"
           @click="$router.push({path: '/mine/edituser'})"
           width="76"
           height="76"
           class="avatar">
      <div class="main-info">
        <div class="name">{{userInfo.name?userInfo.name:'未登录'}}</div>
        <div class="phone">
          <img src="@/assets/phone.png"
               alt="手机"
               width="19"
               height="19">
          <span class="text" v-if="userInfo.phone">{{userInfo.phone}}</span>
          <span class="text" v-if="!userInfo.phone">请绑定手机号</span>
        </div>
        <div class="star">创客积分:
          <span style="color: #FFEE00">{{userInfo.star}}</span>
        </div>
        <div class="star">邀请码:
          <span style="color: #FFEE00">{{userInfo.code}}</span>
        </div>
      </div>
      <div class="distributor">
        <img src="@/assets/distributor.png"
             alt="成为高级VIP创客"
             width="16"
             height="16">
        <span class="text" v-if="userInfo.isvip == 0" @click="$router.push({path:'/mine/vip/interests'})">成为VIP创客</span>
        <span class="text" v-if="userInfo.isvip == 1" @click="$router.push({path:'/mine/vip/interests'})">成为高级VIP创客</span>
        <span class="text" v-if="userInfo.isvip == 2">高级VIP创客</span>
      </div>
    </div>
    <div class="other" style="margin-top: 4px;">
      <van-row>
        <van-col span="8">
          <div>{{userInfo.couponNum}}</div>
          <div @click="coupon">优惠券</div>
        </van-col>
        <van-col span="8">
          <div>{{userInfo.income}}</div>
          <div @click="earnings">我的收益</div>
        </van-col>
        <van-col span="8">
          <div>{{userInfo.balance}}</div>
          <div @click="recharge">
            <span class="charge" v-if="userInfo.isCharge == 1">充值</span>余额
          </div>
        </van-col>
      </van-row>
    </div>
    <!--绑定邀请码-->
    <van-dialog v-model="isShow" @confirm="confirm" title="绑定邀请码" show-cancel-button :before-close="onBeforeClose">
      <input type="text" v-model="code" class="input">
    </van-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {getCurtUser,bindCode} from '@/api/login/index.js'
export default {
  computed: {
    //...mapGetters(['userInfo'])
  },
  props: {
    show:{
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      isLogin: this.show,
      isShow: false,
      code: '',
      userInfo : {}
    }
  },
  watch: {
    show(val) {
      this.isLogin = val;
    }
  },
  created() {
    var openid = localStorage.getItem('openid')
    var user = localStorage.getItem('userInfo')
    if(!user){
      this.$router.push("/login");
    }
    user = JSON.parse(user)
    if (openid || user) {
      getCurtUser({id: user.id,openid : openid}).then(res => {
        if (res.success) {
          this.userInfo = res.data
          if (!this.userInfo.pid && this.isLogin){
            this.isShow = true;
          }
          localStorage.setItem('userInfo',JSON.stringify(res.data))
        }
      })
    }
  },
  methods: {
    onBeforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        // 重置表单校验
        this.code= undefined;
        return done();
      }
    },
    confirm(){
      if (!this.code) {
        this.isShow = true
        this.$toast.fail('请输入邀请码');
        return;
      }
      bindCode({id: this.userInfo.id,pid: this.code}).then(res=>{
        if (res.success) {
          this.isShow = false
          this.$toast.success('绑定成功')
        }else{
          this.$toast.fail(res.msg)
        }
      })
    },
    exit () {
      window.localStorage.removeItem('Authorization')
      window.localStorage.removeItem('userInfo')
      this.$router.push("/login")
    },
    recharge () {
      if (this.userInfo.isCharge){
        this.$router.push("/mineRecharge")
      }
    },
    earnings () {
      this.$router.push("/earnings")
    },
    distribution () {
      this.$router.push("/distribution")
    },
    coupon () {
      this.$router.push("/coupon")
    }
  }
}
</script>

<style lang="less" scoped>
  .input{
    width:100%;
    height:40px;
    border:1px solid rgba(243,243,243,1);
    border-radius:4px;
    padding: 10px;
    font-size:16px;
    font-weight:400;
    line-height:21px;
    color:rgba(199,199,199,1);
    margin-top: 8px;
    text-align: center;
  }
  .user-info {
    width: 100%;
    height: 200px;
    background: linear-gradient(
      235deg,
      rgba(253, 145, 139, 1) 0%,
      rgba(247, 132, 154, 1) 100%
    );
    .exit {
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(255, 255, 255, 1);
      text-align: right;
      padding: 10px 12px 0 0;
    }
    .main {
      padding: 0 12px;
      display: flex;
      flex-direction: row;
      color: #ffffff;
      font-size: 14px;
      position: relative;
      .avatar {
        border-radius: 50%;
      }
      .distributor {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0;
        top: 48px;
        /*width: 150px;*/
        height: 33px;
        background: rgba(254, 234, 238, 1);
        border-radius: 17px 0 0 17px;
        .text {
          /*width: 74px;*/
          height: 18px;
          font-size: 13px;
          font-weight: 400;
          line-height: 18px;
          color: rgba(254, 0, 59, 1);
        }
      }
    }
    .main-info {
      flex: 1;
      .name {
        padding: 9px 10px 8px 10px;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-weight: bold;
      }
      .phone {
        padding: 9px 10px 8px 10px;
        display: inline-flex;
        .text {
          display: block;
          height: 20px;
          line-height: 20px;
        }
      }
      .star {
        padding: 0px 10px 4px 10px;
        height: 20px;
        line-height: 20px;
      }
    }
    .other {
      margin: 0 12px;
      height: 76px;
      background: #ffffff;
      border-radius: 4px;
      text-align: center;
      line-height: 38px;
      color: #333333;
      font-weight: bold;
      font-size: 14px;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      .charge {
        display: inline-block;
        width: 40px;
        height: 29px;
        border-radius: 100px 100px 9px 100px;
        margin-right: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/modules/Info.vue